import { AIRPORT_TRANSFER } from '../products';
import getIcon from './utils/icon';
import { getAvailability, getGraphQlSelection, getPrice, getSelected } from './utils/selection';
import AirportTransfer from './components/AirportTransfer';
const formSection = AIRPORT_TRANSFER.name;
export const airportTransfer = {
  formSection,
  getAvailability,
  getIcon,
  getPrice: getPrice.bind(null, formSection),
  getSelected: getSelected.bind(null, formSection),
  getGraphQlSelection: getGraphQlSelection(formSection),
  ...AIRPORT_TRANSFER
};
export default AirportTransfer;
//# sourceMappingURL=index.js.map